import { Injectable } from '@angular/core';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { FilterDTO, FilterOperator, PagedResultDTOOfVendorScoreCardOverviewDTO, SortDirection, VendorScoreCardClient } from 'src/app/base/models/models.swagger.generated';
import { ToastService } from 'src/app/base/services/toast.service';
import { ShowInactiveService } from 'src/app/base/shared/grid-base/show-inactive.service';
import { IAdaptorService } from 'src/app/base/shared/syncfusion/adaptor-service.interface';
import { ErrorType } from 'src/app/core/routing/error-types';

@Injectable({
  providedIn: 'root'
})
export class VendorScoreCardVendorsService extends ShowInactiveService implements IAdaptorService {

  constructor(
    private vendorScoreCardClient: VendorScoreCardClient,
    public toastService: ToastService,
  ) {
    super();
  }

  public resendEmail(id: number): Observable<any> {
    return this.vendorScoreCardClient.resendVendorScoreCardEmail(id)
      .pipe(
        tap(() => {
          this.toastService.showSuccess('i18n.domain.vendor-score-card.messages.email-sent-successfully-title', 'i18n.domain.vendor-score-card.messages.email-sent-successfully-message');
        }),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }

  getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<PagedResultDTOOfVendorScoreCardOverviewDTO> {
    if (!this.showInactive) {
      if (!filters) {
        filters = [];
      }
      filters.push(new FilterDTO({isComplex: false, field: 'Active', operator: FilterOperator.Equal, value: 'true'}));
    }

    return this.vendorScoreCardClient.searchVendorScoreCards(skip, take, sortBy, sortDirection, filters)
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }
  
  addRecord(data: any): Observable<any> {
    return this.vendorScoreCardClient.createVendorScoreCard(data)
      .pipe(
        tap(() => {
          this.toastService.showSuccess('i18n.domain.vendor-score-card.messages.vendor-added-successfully-title', 'i18n.domain.vendor-score-card.messages.vendor-added-successfully-message');
        }),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }
  updateRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }
  
  deleteRecord(id: number): Observable<any> {
    return this.vendorScoreCardClient.deleteVendorScoreCard(id)
      .pipe(
        tap(() => {
          this.toastService.showSuccess('i18n.domain.vendor-score-card.messages.vendor-deleted-successfully-title', 'i18n.domain.vendor-score-card.messages.vendor-deleted-successfully-message');
        }),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }

}
